import constate from 'constate';
import React, { useState, useRef, useCallback, useLayoutEffect, useEffect } from 'react';
import styled from 'styled-components';
import { Box } from 'hcss-core';
import ReactToPrint from 'react-to-print';
import { Button, Icon } from 'hcss-components';

function usePrint() {
  var _useState = useState(false),
      isPrinting = _useState[0],
      _setIsPrinting = _useState[1];

  var resolve = useRef(); // the reason for the resolve ref and useLayoutEffect is so that we prevent the print preview window
  // from loading until the dom is adjusted for any conditional logic related to printing

  var setIsPrinting = useCallback(function (isPrinting, cb) {
    if (cb) {
      resolve.current = cb;
    }

    _setIsPrinting(isPrinting);
  }, []);
  var contentRef = useRef();
  useLayoutEffect(function () {
    if (isPrinting && resolve.current) {
      resolve.current();
      resolve.current = null;
    }
  }, [isPrinting]);
  return {
    isPrinting: isPrinting,
    setIsPrinting: setIsPrinting,
    contentRef: contentRef
  };
}

var _constate =
/*#__PURE__*/
constate(usePrint),
    PrintProvider = _constate[0],
    usePrintContext = _constate[1];

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  @media print {\n    & {\n      page-break-inside: ", ";\n      page-break-after: ", ";\n      page-break-before: ", ";\n      display: block;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  box-decoration-break: clone;\n  display: ", ";\n\n  @media print {\n    display: block;\n  }\n\n  @page {\n    size: auto;\n    margin: 30pt;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PrintContainer = function PrintContainer(_ref) {
  var className = _ref.className,
      hide = _ref.hide,
      title = _ref.title,
      children = _ref.children;

  var _usePrintContext = usePrintContext(),
      contentRef = _usePrintContext.contentRef,
      isPrinting = _usePrintContext.isPrinting;

  useEffect(function () {
    var originalTitle = window.document.title;

    if (title && isPrinting) {
      window.document.title = title;
    }

    return function () {
      if (title) {
        window.document.title = originalTitle;
      }
    };
  }, [title, isPrinting]);
  if (!isPrinting && hide) return null;
  return React.createElement(Box, {
    className: className,
    ref: contentRef
  }, children);
};

var Print =
/*#__PURE__*/
styled(PrintContainer)(
/*#__PURE__*/
_templateObject(), function (props) {
  return props.hide ? "none" : "block";
}); // eslint-disable-next-line no-unexpected-multiline

var PrintSection =
/*#__PURE__*/
styled(Box)(
/*#__PURE__*/
_templateObject2(), function (props) {
  return props.printOnly ? "none" : "block";
}, function (props) {
  return props.breakInside ? "auto" : "avoid";
}, function (props) {
  return props.breakAfter ? "always" : "auto";
}, function (props) {
  return props.breakBefore ? "always" : "auto";
});
var PrintIgnore = function PrintIgnore(_ref2) {
  var children = _ref2.children;

  var _usePrintContext2 = usePrintContext(),
      isPrinting = _usePrintContext2.isPrinting;

  if (!isPrinting) {
    return React.createElement(React.Fragment, null, children);
  }

  return null;
};

var PrintButton = function PrintButton(_ref) {
  var ButtonComponent = _ref.ButtonComponent;

  var _usePrintContext = usePrintContext(),
      setIsPrinting = _usePrintContext.setIsPrinting,
      contentRef = _usePrintContext.contentRef;

  var getDomReadyForPrint = function getDomReadyForPrint() {
    // see comment in context.ts for why this is necessary
    return new Promise(function (resolve, reject) {
      try {
        setIsPrinting(true, resolve);
      } catch (err) {
        console.error(err);
        setIsPrinting(false);
        reject();
      }
    });
  };

  return React.createElement(ReactToPrint, {
    trigger: function trigger() {
      if (ButtonComponent) return ButtonComponent;
      return React.createElement(Button, {
        hcssStyle: "ThemeInverted",
        style: {
          "float": "right"
        }
      }, React.createElement(Icon, {
        name: "print",
        margin: "right"
      }), "Print");
    },
    content: function content() {
      return contentRef.current;
    },
    onBeforeGetContent: getDomReadyForPrint,
    onAfterPrint: function onAfterPrint() {
      return setIsPrinting(false);
    }
  });
};

export { Print, PrintButton, PrintIgnore, PrintProvider, PrintSection, usePrintContext };
//# sourceMappingURL=hcss-print.esm.js.map
